module.exports = __webpack_public_path__ + "img/www.influenster.com.9243d735.png";